import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Mountain } from "lucide-react";

const NAV_ITEMS = [
  { label: "News", to: "/news", testId: "nav-link-news" },
  { label: "Projects", to: "/projects", testId: "nav-link-projects" },
  { label: "Companies", to: "/companies", testId: "nav-link-companies" },
  { label: "Commodities", to: "/commodities", testId: "nav-link-commodities" },
  { label: "Regions", to: "/regions", testId: "nav-link-regions" },
  {
    label: "Policy Tracker",
    to: "/policy-tracker",
    testId: "nav-link-policy-tracker",
  },
  { label: "Data Room", to: "/data-room", testId: "nav-link-data-room" },
  { label: "Newsletter", to: "/newsletter", testId: "nav-link-newsletter" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 bg-white border-b border-border"
      data-testid="navbar"
    >
      <div className="bb-container flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="brand-logo"
        >
          <span
            className="inline-flex items-center justify-center w-8 h-8 bg-bb-navy text-white"
            aria-hidden="true"
          >
            <Mountain size={18} strokeWidth={2.2} />
          </span>
          <span className="font-archivo font-extrabold tracking-tight text-bb-navy text-lg leading-none">
            BEDROCK
            <span className="text-bb-copper">BULLETIN</span>
          </span>
        </Link>

        <nav
          className="hidden lg:flex items-center gap-7"
          data-testid="navbar-desktop"
        >
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testId}
              className={({ isActive }) =>
                `bb-link text-sm font-medium font-archivo uppercase tracking-wider text-bb-navy hover:text-bb-navy ${
                  isActive ? "text-bb-copper" : ""
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className="lg:hidden text-bb-navy"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-border bg-white"
          data-testid="navbar-mobile"
        >
          <div className="bb-container py-3 flex flex-col">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                data-testid={`${item.testId}-mobile`}
                className={({ isActive }) =>
                  `py-3 border-b border-border last:border-b-0 text-sm font-archivo uppercase tracking-wider ${
                    isActive ? "text-bb-copper" : "text-bb-navy"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
